import styled from 'styled-components';

export const Heading = styled('h2')(({ theme }) => ({
  fontSize: '40rem',
  fontFamily: "'Nexa', sans-serif",
  fontWeight: 700,
  lineHeight: 1.5,
  color: theme.colors.primary_element,
  '@media (max-width: 1200px)': {
    fontSize: '30rem',
  },
  '@media (max-width: 768px)': {
    fontSize: '20rem',
  },
}));
